import {Component, signal, inject, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MatChipsModule} from "@angular/material/chips"
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog"
import {MatInputModule} from "@angular/material/input"
import {MatSelectModule} from "@angular/material/select"
import {Labels} from "@labels"
import {MaterialAiDialogResult} from "@platform/models/dialogs/material-ai-dialog-result"
import {MatCheckboxModule} from "@angular/material/checkbox"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-material-ai-dialog",
    templateUrl: "./material-ai-dialog.component.html",
    styleUrls: ["./material-ai-dialog.component.scss"],
    imports: [FormsModule, MatDialogModule, MatInputModule, MatSelectModule, MatButtonModule, MatChipsModule, MatCheckboxModule],
})
export class MaterialAiDialogComponent {
    readonly $result = signal<MaterialAiDialogResult>({
        generateDisplacement: false,
        ignoreDpi: false,
        tags: [],
        filterRadius: undefined,
    })

    tagOptions: [number, string][] = Array.from(Labels.MaterialAiTag.values()).map((entry) => [entry.state, entry.label])
    readonly dialogRef = inject(MatDialogRef<MaterialAiDialogComponent>)
    readonly data = inject(MAT_DIALOG_DATA, {optional: true})

    cancelAction(): void {
        this.dialogRef.close(false)
    }

    confirmAction(): void {
        this.$result().filterRadius ??= undefined
        this.dialogRef.close(this.$result())
    }

    addTag(tag: number): void {
        if (!this.$result().tags.includes(tag)) {
            this.$result.update((current) => ({...current, tags: [...current.tags, tag]}))
        }
    }

    removeTag(tag: number): void {
        this.$result.update((current) => ({...current, tags: current.tags.filter((t) => t !== tag)}))
    }

    tagLabel(tag: number): string {
        return Labels.MaterialAiTag.get(tag)?.label ?? ""
    }
}
